import { useNavigate, Link } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { TensionLogo } from '../TensionLogo';

export type MarketingNavKey = 'blog' | 'resources' | 'guides' | 'press' | 'about';

type Props =
  | { variant: 'hub'; activeNav: MarketingNavKey }
  | { variant: 'article' };

export function MarketingSiteHeader(props: Props) {
  const navigate = useNavigate();

  const linkClass = (key: MarketingNavKey) =>
    `text-sm font-medium transition-colors ${
      props.variant === 'hub' && props.activeNav === key
        ? 'text-slate-900'
        : 'text-slate-600 hover:text-slate-900'
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/98 shadow-[0_10px_24px_rgba(15,23,42,0.08)] backdrop-blur-[6px]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between md:h-20">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 rounded-xl px-1 py-1.5 transition-opacity hover:opacity-95"
            aria-label="TENSION home"
          >
            <TensionLogo tone="dark" height={58} priority className="h-auto max-w-[240px] sm:max-w-[300px] md:max-w-[340px]" />
          </button>

          {props.variant === 'article' ? (
            <div className="flex items-center gap-3">
              <Button
                onClick={() => navigate('/blog')}
                variant="outline"
                size="sm"
                className="border-slate-300 bg-white text-slate-900 hover:bg-slate-50"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Blog
              </Button>
            </div>
          ) : (
            <nav className="flex flex-wrap items-center justify-end gap-3 sm:gap-5" aria-label="Marketing">
              <button type="button" onClick={() => navigate('/blog')} className={linkClass('blog')}>
                Blog
              </button>
              <button type="button" onClick={() => navigate('/resources')} className={linkClass('resources')}>
                Resources
              </button>
              <button type="button" onClick={() => navigate('/guides')} className={linkClass('guides')}>
                Guides
              </button>
              <button type="button" onClick={() => navigate('/press')} className={linkClass('press')}>
                Press
              </button>
              <button type="button" onClick={() => navigate('/about')} className={linkClass('about')}>
                About
              </button>
              <Button
                type="button"
                onClick={() => navigate('/early-access')}
                size="sm"
                className="bg-gradient-to-r from-cyan-500 to-purple-600 text-white hover:from-cyan-400 hover:to-purple-500"
              >
                Start Early Access
              </Button>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
}
